import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { timeout, map } from 'rxjs/operators';

const mainUrl = environment.url;

@Injectable({
  providedIn: 'root'
})
export class BrokerService {

  constructor(private http: HttpClient) { }

  getAllBrokersPaged(page, size): Observable<any> {
    return this.http.get(mainUrl + `broker/paged?page=${page}&size=${size}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getAllBrokers(): Observable<any> {
    return this.http.get(mainUrl + `broker`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }
  getAllBrokersTwo(): Observable<any> {
    return this.http.get(mainUrl + `broker`)
      .pipe(
        timeout(30000),
        map((res: any) => res)
      )
  }

  getBrokerById(id): Observable<any> {
    return this.http.get(mainUrl + `broker/${id}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  createBroker(form): Observable<any> {
    return this.http.post(mainUrl + 'broker', form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  editBroker(form, id): Observable<any> {
    return this.http.put(mainUrl + `broker/${id}`, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getAllUsersByBrokerPaged(id, page, size): Observable<any> {
    return this.http.get(mainUrl + `broker/users/paged/${id}?page=${page}&size=${size}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getAllUsersByBroker(id): Observable<any> {
    return this.http.get(mainUrl + `broker/users/${id}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  deleteBroker(id): Observable<any> {
    return this.http.delete(mainUrl + `broker/${id}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  createBrokerUser(form): Observable<any> {
    return this.http.post(mainUrl + `broker/mediator`, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  editBrokerUser(form, id): Observable<any> {
    return this.http.put(mainUrl + `broker/mediator/${id}`, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  deleteBrokerUser(id): Observable<any> {
    return this.http.delete(mainUrl + `broker/mediator/${id}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getBrokerReport(): Observable<any> {
    return this.http.post(mainUrl + `broker/users-report`, {}, { reportProgress: true, observe: 'response', responseType: 'blob' })
      .pipe(
        timeout(30000),
        map((res: any) => res.body)
      )
  }

  getHeader() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': window.localStorage.getItem('token')
    });

    return headers;
  }
}
